import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                <span className="text-primary-500">073</span>
                <span className="text-background-50">漫画网</span>
              </span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed">
              免费韩国漫画阅读平台，为您精心挑选最优质的漫画作品。每日更新，精彩不断。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-background-50/60 hover:text-primary-400 transition-colors text-sm">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-background-50/60 hover:text-primary-400 transition-colors text-sm">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-background-50/60 hover:text-primary-400 transition-colors text-sm">品牌介绍</Link></li>
              <li><a href="/about#reputation" className="text-background-50/60 hover:text-primary-400 transition-colors text-sm">用户口碑</a></li>
              <li><a href="/about#contact" className="text-background-50/60 hover:text-primary-400 transition-colors text-sm">联系我们</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; 2026 073漫画网 - 免费韩国漫画阅读平台，版权所有
          </p>
          <p className="text-background-50/30 text-xs">
            本站所有漫画均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}